import React from 'react';
import './Header.scss';

interface HeaderProps {
    title: React.ReactNode;
    children?: React.ReactNode;
}

function Header(props: HeaderProps): JSX.Element {
    const h = (
        <header id="h">
            <ul className="menu-list">
                <li className="title">{props.title}</li>
                <li className="ml-auto"></li>
                <li className=""></li>
                {props.children}
            </ul>
        </header>
    );
    return h;
}
  
export default Header;
